import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useTheme,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImageCard from '../ImageCard';

const policiesData = [
  {
    title: 'Re-enrolments',
    description:
      'To secure your child’s place for the next term, please notify SJ Swimming via email or SMS. If we do not receive confirmation, we may offer the place to another student. We encourage families to confirm promptly to avoid disappointment.',
  },
  {
    title: 'Lesson Payments',
    description:
      'Lesson fees are payable at the beginning of each term. Thank you for ensuring timely payment so we can continue delivering high-quality lessons.',
  },
  {
    title: 'Missed Lessons',
    description:
      'We understand that absences can occur. For illness or sick leave, we require at least 24 hours’ notice to arrange a make-up lesson. For personal leave or travel, two weeks’ notice is required. All missed lessons must be notified in advance, and make-up lessons must be booked accordingly.',
  },
  {
    title: 'Make-Up Lessons',
    description:
      'Students are eligible for up to three make-up lessons per term. Make-up lessons must be used within the same term and cannot be carried over or transferred to holiday programs. If no advance notice is provided, the make-up lesson will be cancelled at the discretion of SJ Swimming management.',
  },
  {
    title: 'Credits',
    description:
      'Credits are offered only at the discretion of SJ Swimming management, typically in the event of a pool or class cancellation.',
  },
  {
    title: 'Extra Lessons',
    description:
      'Extra lessons are available for students with an existing term booking. We are unable to accommodate one-off casual bookings during the term. The fee for extra lessons is $35.00 per lesson for both Learn to Swim and Squad programs.',
  },
];

const Policies = () => {
  const theme = useTheme();

  const boxStyle = {
    p: 2,
    borderRadius: 2,
    boxShadow: 3,
    bgcolor: theme.palette.primary.main,
    color: theme.palette.background.paper,
    mb: 2,
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      {/* Heading */}
      <Typography
        variant="h1"
        sx={{ textAlign: 'center', color: theme.palette.primary.main }}
        gutterBottom
      >
        Our Policies
      </Typography>

      {/* Intro */}
      <Typography variant="body1" sx={{ textAlign: 'center', mb: 4 }}>
        Here’s a quick look at our policies, thank you for your understanding and support! This helps us keep things running smoothly and ensures everyone has a great experience.
      </Typography>

      {/* Policies + Images */}
      <Grid container spacing={4}>
        {/* Left Side: Policies */}
        <Grid item xs={12} md={6}>
          {policiesData.map((policy, index) => (
            <Accordion key={index} sx={{ ...boxStyle }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: theme.palette.background.paper }} />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
              >
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                  {policy.title}
                </Typography>
              </AccordionSummary>
              <AccordionDetails sx={{ bgcolor: '#f7f7f7', color: '#17204a', borderRadius: 2 }}>
                <Typography variant="body2">{policy.description}</Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>

        {/* Right Side: Static Images */}
        <Grid item xs={12} md={6}>
          <ImageCard
            src="/images/SJ_Gallery/SQ_Su_1.jpg"
            alt="Swimming Policy 1"
            height={400}
            objectFit='contain'
            objectPosition="center"
          /> 
          
          <ImageCard
            src="/images/SJ_Gallery/LTS_2.jpg"
            alt="Swimming Policy 2"
            height={400}
            objectFit='contain'
            objectPosition="center"
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Policies;